import React from "react";

export default function DiskGauge({ percent = 0, usedGb = 0, limitGb = 40, fileCount = 0, serverUsedGb = 0, serverTotalGb = 0 }) {
  const pct = Math.max(0, Math.min(100, percent));
  const r = 64;
  const c = 2 * Math.PI * r;
  const offset = c - (pct / 100) * c;
  const color = pct > 85 ? "#EF4444" : pct > 60 ? "#FF9F0A" : "#FF3B30";

  return (
    <div className="brand-surface rounded-2xl p-6 hover-lift" data-testid="disk-usage-gauge">
      <div className="flex items-center justify-between mb-4">
        <div className="text-overline">Disk Usage</div>
        <div className="text-[11px] text-zinc-500">Limit {limitGb} GB</div>
      </div>
      <div className="flex items-center gap-6">
        <div className="relative" style={{ width: 150, height: 150 }}>
          <svg width="150" height="150" viewBox="0 0 150 150" className="-rotate-90">
            <circle cx="75" cy="75" r={r} stroke="rgba(255,255,255,0.08)" strokeWidth="10" fill="none" />
            <circle cx="75" cy="75" r={r} stroke={color} strokeWidth="10" fill="none"
              strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round"
              style={{ transition: "stroke-dashoffset 0.8s ease, stroke 0.3s" }} />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <div className="font-mono font-bold text-3xl" style={{ color }}>{pct.toFixed(1)}%</div>
            <div className="text-[10px] uppercase tracking-widest text-zinc-500 mt-1">of {limitGb}GB</div>
          </div>
        </div>
        <div className="flex-1 space-y-3">
          <Row label="Uploads" value={`${usedGb.toFixed(3)} GB`} />
          <Row label="Files stored" value={fileCount.toLocaleString()} />
          <Row label="Server used" value={`${serverUsedGb.toFixed(1)} / ${serverTotalGb.toFixed(1)} GB`} />
          <div className="text-[11px] text-zinc-500 pt-2 border-t border-white/5">Photos auto-delete after 90 days.</div>
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between text-sm">
      <span className="text-zinc-500">{label}</span>
      <span className="font-mono font-semibold">{value}</span>
    </div>
  );
}
